import { CardContent } from 'shared-components';
import { FormLayout } from 'shared-components';
import { useGetLicensesQuery } from './licenses.api';
import { useState } from 'react';
import { DateTime } from '../datetime/datetime';

export const SettingsLicenses = () => {
  const [page] = useState<number>(1);
  const [includeInactive] = useState<boolean>(false);
  const [perPage] = useState<number>(100);

  const {
    data: licenses,
    isLoading,
    isFetching,
  } = useGetLicensesQuery({
    includeInactive,
    page,
    perPage,
  });
  return (
    <CardContent>
      <FormLayout>
        <h1>Licenses</h1>
        <p>Manage the licenses for your application.</p>
        {isLoading || isFetching ? (
          <div>Loading licenses...</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Status</th>
                <th>Max Screens</th>
                <th>Plan</th>
                <th>Type</th>
                <th>Expires At</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {licenses?.data.map((license) => (
                <tr key={license._id.toString()}>
                  <td>{license._id.toString()}</td>
                  <td>{license.status}</td>
                  <td>{license.maxScreens}</td>
                  <td>{license.plan}</td>
                  <td>{license.type}</td>
                  <td>
                    <DateTime d={license.expiresAt} />
                  </td>
                  <td>
                    <DateTime d={license.createdAt} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </FormLayout>
    </CardContent>
  );
};
